import * as React from 'react'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'

import { isFrenchLocale } from 'lib/utility/LocaleHelper'

type Props = {
  handleChangeLocale: () => void
}

const ChangeLocale = (props: Props) => {
  const { t } = useTranslation()

  const getChangeLocaleText = () => {
    return isFrenchLocale()
      ? t('sidebar.switchToEnglish')
      : t('sidebar.switchToFrench')
  }

  return (
    <Button onClick={props.handleChangeLocale}>{getChangeLocaleText()}</Button>
  )
}

export default ChangeLocale
